import Vue from 'vue'
import VueRouter from 'vue-router'
import Index from '../views/index.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Index',
    component: Index
  },
  {
    path: '/about',
    name: 'About',
    component: () => import('../views/About.vue'),
  },
  {
    path: '/industryInterviews',
    name: 'IndustryInterviews',
    component: () => import('../views/IndustryInterviews.vue'),
  },
  {
    path: '/news',
    name: 'News',
    component: () => import('../views/News/News.vue'),
  },
  {
    path: '/newsDetail',
    name: 'NewsDetail',
    component: () => import('../views/News/NewsDetail.vue'),
  },
  {
    path: '/designer',
    name: 'Designer',
    component: () => import('../views/ServiceProjects/Designer.vue'),
  },
  {
    path: '/designerDetail',
    name: 'DesignerDetail',
    component: () => import('../views/ServiceProjects/DesignerDetail.vue'),
  },
  {
    path: '/selectedProjects',
    name: 'SelectedProjects',
    component: () => import('../views/ServiceProjects/SelectedProjects.vue'),
  },
  {
    path: '/successProjects',
    name: 'SuccessProjects',
    component: () => import('../views/ServiceProjects/SuccessProjects.vue'),
  },
  {
    path: '/projectsDetail',
    name: 'ProjectsDetail',
    component: () => import('../views/ProjectsDetail.vue'),
  },{
    path: '/detail',
    name: 'detail',
    component: () => import('../views/detail.vue'),
  },
  {
    path: '/projectsDetailSystem',
    name: 'ProjectsDetailSystem',
    component: () => import('../views/ProjectsDetailSystem.vue'),
  },
  {
    path: '/resourceShare',
    name: 'ResourceShare',
    component: () => import('../views/Channel/ResourceShare.vue'),
  },
  {
    path: '/resourceShareDetail',
    name: 'ResourceShareDetail',
    component: () => import('../views/Channel/ResourceShareDetail.vue'),
  },
  {
    path: '/service',
    name: 'Service',
    component: () => import('../views/Channel/Service.vue'),
  },
  {
    path: '/serviceDetail',
    name: 'ServiceDetail',
    component: () => import('../views/Channel/ServiceDetail.vue'),
  },
  {
    path: '/serviceProductlview',
    name: 'ServiceProductlview',
    component: () => import('../views/Channel/ServiceProductlview.vue'),
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import('../views/Login.vue'),
  },
  {
    path: '/register',
    name: 'Register',
    component: () => import('../views/Register.vue'),
  },
  {
    path: '/personalCenter',
    // name:'PersonalCenter',
    redirect: '/myIndex',
    component: () => import('../views/PersonalCenter.vue'),
    children: [
      { path: '/myIndex', component: () => import('../views/Grzx/MyIndex.vue') },
      { path: '/myPersonalInfo', component: () => import('../views/Grzx/PersonalInfo.vue') },
      { path: '/myChangePassword', component: () => import('../views/Grzx/ChangePassword.vue') },
      { path: '/myProjectRelease', component: () => import('../views/Grzx/MyProjectRelease.vue') },
      { path: '/projectRelease', component: () => import('../views/Grzx/projectRelease.vue') },
      { path: '/projectList', component: () => import('../views/Grzx/projectList.vue') },
      { path: '/projectDetail', component: () => import('../views/Grzx/projectDetail.vue') },
      { path: '/myParticipation', component: () => import('../views/Grzx/MyParticipation.vue') },
      { path: '/myCollection', component: () => import('../views/Grzx/MyCollection.vue') },
      { path: '/myComment', component: () => import('../views/Grzx/MyComment.vue') },
      { path: '/mySystemMessages', component: () => import('../views/Grzx/SystemMessages.vue') },
      { path: '/myMessage', component: () => import('../views/Grzx/MyMessage.vue') },
      { path: '/myProjectDetail', component: () => import('../views/Grzx/MyProjectDetail.vue') },
      { path: '/myProjectList', component: () => import('../views/Grzx/MyProjectList.vue') },
      { path: '/myAudits', component: () => import('../views/Grzx/MyAudits.vue') },
      { path: '/myProductManual', component: () => import('../views/Grzx/MyProductManual.vue') },

    ]
  },
  
]

const router = new VueRouter({
  // mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior: () => ({ left: 0, top: 0 })

})
//  
router.beforeEach((to, from, next) => {
  document.title = to.meta.title || '户外视觉媒体产业平台';

  // 构建meta标签
  const meta = [
    { name: 'description', content: '户外视觉媒体产业平台' },
    { name: 'abstract', content: '户外视觉媒体产业平台' },
    { name: 'keywords', content: 'RDI、户外视觉媒体产业平台' },
    // 如果需要abstract，则添加到meta标签中
    // { name: 'abstract', content: to.meta.abstract }
  ];
 
  // 清除现有的meta标签
  document.querySelectorAll('meta[name="description"], meta[name="keywords"], meta[name="abstract"]').forEach(el => {
    el.remove();
  });
 
  // 添加新的meta标签
  meta.forEach(m => {
    if (m.content) {
      const tag = document.createElement('meta');
      tag.setAttribute('name', m.name);
      tag.setAttribute('content', m.content);
      document.head.appendChild(tag);
    }
  });

  next();
  // if (to.path == from.path) {
  //   next(false)
  // } else {
  //   next();
  // }
});

export default router
